import api from './api';

const BASE_PATH = '/item_reviews';

/**
 * Cliente da API de revisão pedagógica de itens (Projeto Floriano).
 * Backend em backend/app/controllers/api/v1/item_reviews_controller.rb.
 *
 * O endpoint usa axios direto (não jsonapi-react client) para suportar
 * filtros encadeados via params e actions custom (approve/reject/etc.).
 */
export const itemReviewsApi = {
  // Listagem + filtros
  // filters: { status, codigo_descritor, componente, origin, generator_model,
  //            reviewer_id, has_critical_alert }
  // pagination: { page, perPage }
  index: ({ filters = {}, page = 1, perPage = 25 } = {}) => {
    const params = { page, per_page: perPage };
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        params[`filter[${k}]`] = v;
      }
    });
    return api.get(BASE_PATH, { params });
  },

  show: id => api.get(`${BASE_PATH}/${id}`),

  // Cria uma revisão "puxando" o item para mim. Idempotente:
  // se já houver uma em em_revisao, devolve a existente.
  claim: questionId => api.post(BASE_PATH, { question_id: questionId }),

  approve: (id, { notes } = {}) =>
    api.post(`${BASE_PATH}/${id}/approve`, { notes }),

  reject: (id, { notes } = {}) =>
    api.post(`${BASE_PATH}/${id}/reject`, { notes }),

  requestRevision: (id, { notes } = {}) =>
    api.post(`${BASE_PATH}/${id}/request_revision`, { notes }),

  verifyImage: (id, verified) =>
    api.post(`${BASE_PATH}/${id}/verify_image`, { verified }),

  dashboard: () => api.get(`${BASE_PATH}/dashboard`),

  // Comentários
  comments: {
    create: (reviewId, body) =>
      api.post(`${BASE_PATH}/${reviewId}/comments`, { body }),
    update: (reviewId, commentId, patch) =>
      api.patch(`${BASE_PATH}/${reviewId}/comments/${commentId}`, patch),
    destroy: (reviewId, commentId) =>
      api.delete(`${BASE_PATH}/${reviewId}/comments/${commentId}`)
  }
};

export default itemReviewsApi;
